import { render, staticRenderFns } from "./SectionCancel.vue?vue&type=template&id=35c83b7a&scoped=true"
import script from "./SectionCancel.vue?vue&type=script&lang=js"
export * from "./SectionCancel.vue?vue&type=script&lang=js"
import style1 from "./SectionCancel.vue?vue&type=style&index=1&id=35c83b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c83b7a",
  null
  
)

export default component.exports